import { render, staticRenderFns } from "./tier-icon.vue?vue&type=template&id=7154c6ce"
import script from "./tier-icon.vue?vue&type=script&lang=js"
export * from "./tier-icon.vue?vue&type=script&lang=js"
import style0 from "./tier-icon.vue?vue&type=style&index=0&id=7154c6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports